// extracted by mini-css-extract-plugin
export default {"container":"Survey_container__FUeNq","containerSmall":"Survey_containerSmall__FDbST"};